module.exports = __webpack_public_path__ + "img/scene15.ab62a900.gif";